// extracted by mini-css-extract-plugin
export default {"handle":"resize-handle_handle__DgEMb","handle-horizontal":"resize-handle_handle-horizontal__pKwdJ"};